import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  setMinimised,
  setModalOpen,
  setNotificationOpen,
} from "../../../store/timer/timer.reducer";
import {
  selectDeadline,
  selectNotificationText,
  selectNotificationVisible,
} from "../../../store/timer/timer.selector";
import {
  MinimisedNotificationWrapper,
  Minimiser,
  NotificationContainer,
  NotificationContent,
  NotificationDescription,
  NotificationIcon,
  NotificationTitle,
  NotificationWrapper,
  StyledCountdown,
} from "./notification.styles";
import {
  ExclamationCircleOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import Draggable from "react-draggable";
import { isScreenLarger } from "../../../utils/utils";
import { setDeadline } from "../../../store/timer/timer.reducer";

export const Notification = () => {
  const dispatch = useDispatch();
  const deadline = useSelector(selectDeadline);
  const notificationText = useSelector(selectNotificationText);
  const visible = useSelector(selectNotificationVisible);

  const onFinish = () => {
    dispatch(setDeadline(0));
    dispatch(setNotificationOpen(false));
  };
  const onClick = () => {
    dispatch(setModalOpen(true));
  };

  const onMinimise: React.MouseEventHandler<HTMLDivElement> = (event) => {
    event.stopPropagation();
    event.preventDefault();
    dispatch(setMinimised(true));
  };

  return visible ? (
    <Draggable>
      <NotificationWrapper onClick={onClick}>
        {!isScreenLarger ? (
          <Minimiser onClick={onMinimise}>
            <MinusCircleOutlined />
          </Minimiser>
        ) : null}
        <NotificationContainer>
          <NotificationIcon>
            <ExclamationCircleOutlined />
          </NotificationIcon>
          <NotificationContent>
            <NotificationTitle>{notificationText}</NotificationTitle>
            <NotificationDescription>
              <StyledCountdown
                prefix="Click to Continue - "
                format="mm:ss"
                value={deadline}
                onFinish={onFinish}
              />
            </NotificationDescription>
          </NotificationContent>
        </NotificationContainer>
      </NotificationWrapper>
    </Draggable>
  ) : null;
};

export const MinimisedNotification = () => {
  const dispatch = useDispatch();
  const deadline = useSelector(selectDeadline);
  const visible = useSelector(selectNotificationVisible);

  const onMaximise = () => {
    dispatch(setMinimised(false));
  };
  const onFinish = () => {
    dispatch(setDeadline(0));
    dispatch(setNotificationOpen(false));
  };

  return visible ? (
    <MinimisedNotificationWrapper onClick={onMaximise}>
      <StyledCountdown format="mm:ss" value={deadline} onFinish={onFinish} />
    </MinimisedNotificationWrapper>
  ) : null;
};
